// extracted by mini-css-extract-plugin
module.exports = {"root":"finans_root__I4dRK","in-view":"finans_in-view__j860k","desc":"finans_desc__NjMXp","alternatives":"finans_alternatives__fREKy","disclamer":"finans_disclamer__OGHN5"};